@file:OptIn(InternalResourceApi::class)

package com.xtream.sharedResources.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.xtream.sharedResources.resources/"

@delegate:ResourceContentHash(2_065_985_441)
public val Res.drawable.clapper_open: DrawableResource by lazy {
      DrawableResource("drawable:clapper_open", setOf(
        ResourceItem(setOf(), "${MD}drawable/clapper_open.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_318_277_072)
public val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_736_550_670)
public val Res.drawable.gear_filled: DrawableResource by lazy {
      DrawableResource("drawable:gear_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/gear_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_014_152_871)
public val Res.drawable.home: DrawableResource by lazy {
      DrawableResource("drawable:home", setOf(
        ResourceItem(setOf(), "${MD}drawable/home.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(625_824_133)
public val Res.drawable.home_2: DrawableResource by lazy {
      DrawableResource("drawable:home_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_2.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(752_172_789)
public val Res.drawable.home_24px: DrawableResource by lazy {
      DrawableResource("drawable:home_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_482_342_772)
public val Res.drawable.mail: DrawableResource by lazy {
      DrawableResource("drawable:mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/mail.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_956_263_756)
public val Res.drawable.passkey_24px: DrawableResource by lazy {
      DrawableResource("drawable:passkey_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/passkey_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(767_350_689)
public val Res.drawable.screen_ic: DrawableResource by lazy {
      DrawableResource("drawable:screen_ic", setOf(
        ResourceItem(setOf(), "${MD}drawable/screen_ic.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(982_543_405)
public val Res.drawable.sparkle: DrawableResource by lazy {
      DrawableResource("drawable:sparkle", setOf(
        ResourceItem(setOf(), "${MD}drawable/sparkle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_297_782_455)
public val Res.drawable.telegram: DrawableResource by lazy {
      DrawableResource("drawable:telegram", setOf(
        ResourceItem(setOf(), "${MD}drawable/telegram.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_214_501_860)
public val Res.drawable.tmdb: DrawableResource by lazy {
      DrawableResource("drawable:tmdb", setOf(
        ResourceItem(setOf(), "${MD}drawable/tmdb.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(33_761_522)
public val Res.drawable.tv_ic: DrawableResource by lazy {
      DrawableResource("drawable:tv_ic", setOf(
        ResourceItem(setOf(), "${MD}drawable/tv_ic.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_241_642_886)
public val Res.drawable.tv_ic1: DrawableResource by lazy {
      DrawableResource("drawable:tv_ic1", setOf(
        ResourceItem(setOf(), "${MD}drawable/tv_ic1.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_406_732_637)
public val Res.drawable.tv_ic2: DrawableResource by lazy {
      DrawableResource("drawable:tv_ic2", setOf(
        ResourceItem(setOf(), "${MD}drawable/tv_ic2.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-941_748_817)
public val Res.drawable.user_filled: DrawableResource by lazy {
      DrawableResource("drawable:user_filled", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_filled.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_432_604_848)
public val Res.drawable.whatsapp: DrawableResource by lazy {
      DrawableResource("drawable:whatsapp", setOf(
        ResourceItem(setOf(), "${MD}drawable/whatsapp.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_035_032_862)
public val Res.drawable.www: DrawableResource by lazy {
      DrawableResource("drawable:www", setOf(
        ResourceItem(setOf(), "${MD}drawable/www.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_780_443_248)
public val Res.drawable.youtube_ic24: DrawableResource by lazy {
      DrawableResource("drawable:youtube_ic24", setOf(
        ResourceItem(setOf(), "${MD}drawable/youtube_ic24.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("clapper_open", Res.drawable.clapper_open)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("gear_filled", Res.drawable.gear_filled)
  map.put("home", Res.drawable.home)
  map.put("home_2", Res.drawable.home_2)
  map.put("home_24px", Res.drawable.home_24px)
  map.put("mail", Res.drawable.mail)
  map.put("passkey_24px", Res.drawable.passkey_24px)
  map.put("screen_ic", Res.drawable.screen_ic)
  map.put("sparkle", Res.drawable.sparkle)
  map.put("telegram", Res.drawable.telegram)
  map.put("tmdb", Res.drawable.tmdb)
  map.put("tv_ic", Res.drawable.tv_ic)
  map.put("tv_ic1", Res.drawable.tv_ic1)
  map.put("tv_ic2", Res.drawable.tv_ic2)
  map.put("user_filled", Res.drawable.user_filled)
  map.put("whatsapp", Res.drawable.whatsapp)
  map.put("www", Res.drawable.www)
  map.put("youtube_ic24", Res.drawable.youtube_ic24)
}
